import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import moment from "moment";

const ShowReceipt = ({ token, receiptData, loading, error, onClose }) => {
  const topRef = useRef(null);

 useEffect(() => {
  // Only scroll within the modal content, not the entire window
  if (topRef.current) {
    topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}, [token]);

  if (loading) {
    return (
<div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto', zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Receipt</h6>
              <button type="button" className="btn-close" 
               style={{ backgroundColor: "transparent" }}
              onClick={onClose}></button>
            </div>
            <div className="modal-body text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading receipt data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
     <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto', zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Receipt</h5>
              <button type="button" className="btn-close" 
               style={{ backgroundColor: "transparent" }}
              onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="alert alert-danger">
                Error loading receipt: {error}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!receiptData) {
    return (
      <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto', zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Receipt</h5>
              <button type="button" className="btn-close" 
               style={{ backgroundColor: "transparent" }}
              onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="alert alert-info">No receipt data available</div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div ref={topRef}></div>

          {/* Modal Header */}
          <div className="modal-header">
            <h6 className="modal-title">Order Receipt</h6>
            <button
              type="button"
              className="btn-close"
              style={{ backgroundColor: "transparent" }}
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            {/* Receipt Header */}
            <div className="card mb-2">
              <div className="card-body p-3">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <h6 className="fw-bold text-dark mb-2">Token Number <span className="token-number  text-primary mb-1">#{receiptData.tokenNumber}</span></h6>
                    <p className="category text-muted mb-1">Categories: {receiptData.categories?.join(", ") || "N/A"}</p>
                    <p className="order-date text-muted mb-0">
                      Order Date: {moment(receiptData.createdAt).format("YYYY/MM/DD")}
                    </p>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <h6 className=" fw-bold text-dark mb-2">Total Amount</h6>
                    <p className="total-amount text-primary mb-0">
                      ₹{receiptData.receiptTotal?.toFixed(2) || "0.00"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Items */}
            <div className="card mb-3">
              <div className="card-body p-3">
                <h6 className=" fw-bold text-dark mb-3">Order Items</h6>
                <div className="table-responsive">
                  <table className="table order-items-table mb-0">
                    <thead>
                      <tr>
                        <th className="border-0">Product Name</th>
                        <th className="border-0">Category</th>
                        <th className="border-0">Price</th>
                        <th className="border-0">Quantity</th>
                        <th className="border-0">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receiptData.items && receiptData.items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.productName}</td>
                          <td>{item.categoryName}</td>
                          <td>₹{item.price?.toFixed(2) || "0.00"}</td>
                          <td>{item.quantity}</td>
                          <td>₹{item.total?.toFixed(2) || "0.00"}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="table-total-row">
                        <td colSpan="4" className="text-end fw-bold border-0">
                          Grand Total:
                        </td>
                        <td className="fw-bold text-primary border-0">
                          ₹{receiptData.receiptTotal?.toFixed(2) || "0.00"}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-2 mb-3">
            <p className="powered-by text-muted small mb-0">
              © 2025 - Powered by Belinnov Solutions
            </p>
          </div>
        </div>
      </div>

      <style>
        {`
          .section-title {
            font-size: 1rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 0.5rem;
          }
          .order-items-table th {
            background-color: #f8f9fa;
            font-weight: 600;
            padding: 0.75rem 0.5rem;
          }
          .order-items-table td {
            padding: 0.5rem;
            vertical-align: middle;
          }
          .table-total-row {
            background-color: #f8f9fa;
          }
          .modal-content {
            max-height: 90vh;
            overflow-y: auto;
          }
          .card {
            border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          }
          @media print {
            .modal-footer, .powered-by {
              display: none !important;
            }
            .modal-content {
              border: none;
              box-shadow: none;
            }
          }
            body.modal-open {
  overflow: hidden;
}
        `}
      </style>
    </div>
  );
};

ShowReceipt.propTypes = {
  token: PropTypes.shape({
    tokenNumber: PropTypes.string,
    latestCreatedAt: PropTypes.string
  }),
  receiptData: PropTypes.shape({
    tokenNumber: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    createdAt: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        productId: PropTypes.string,
        productName: PropTypes.string,
        categoryName: PropTypes.string,
        quantity: PropTypes.number,
        price: PropTypes.number,
        total: PropTypes.number
      })
    ),
    receiptTotal: PropTypes.number
  }),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

ShowReceipt.defaultProps = {
  token: null,
  receiptData: null,
  loading: false,
  error: null
};

export default ShowReceipt;